import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { PageBanner } from "@/components/site/PageBanner";
import { RideForm } from "@/components/kmt/RideForm";
import { publicApi } from "@/lib/api";

export default function Book() {
  const [ref, setRef] = useState<string | null>(null);
  const [params] = useSearchParams();
  const initial = Object.fromEntries(["service", "pickup_address", "dropoff_address", "pickup_date", "pickup_time"]
    .filter((k) => params.get(k)).map((k) => [k, params.get(k) as string]));
  return (
    <>
    <PageBanner title="Book a Ride" crumb="Book a Ride" />
    <div className="mx-auto grid max-w-7xl gap-14 px-5 py-20 md:px-10 lg:grid-cols-[0.8fr_1.2fr]">
      <div>
        <p className="eyebrow">Ride request</p>
        <h2 className="mt-4 font-display text-3xl md:text-4xl">Request your ride.</h2>
        <div className="gold-rule mt-8 w-40" />
        <ul className="mt-8 flex flex-col gap-4 text-[15px] leading-relaxed text-mist/80">
          <li>This is a request, not a booking. No payment is taken here.</li>
          <li>Kyia will review your trip and text you a quote.</li>
          <li>All times are Central time.</li>
          <li>Same-day rides and rides within 24 hours are paid in full once quoted.</li>
        </ul>
      </div>
      <div className="relative rounded-md border border-gold/25 bg-aubergine/70 p-6 md:p-10">
        {ref !== null ? (
          <div className="flex flex-col items-start gap-5 py-10" data-testid="book-success">
            <CheckCircle2 className="text-gold" size={40} />
            <h2 className="font-display text-3xl">Request received.</h2>
            <p className="text-[15px] text-mist/85">Kyia will text you a quote soon.{ref && <> Your request number is <strong className="text-gold" data-testid="book-success-ref">{ref}</strong>.</>}</p>
            <p className="font-script text-3xl text-gold">Thank you for choosing KMT Private Rides!</p>
          </div>
        ) : (
          <RideForm submitLabel="Send request" initial={initial} onSubmit={async (p) => {
            const r = await publicApi.post("/public/requests", p);
            setRef(r.data.ref || "");
          }} />
        )}
      </div>
    </div>
    </>
  );
}
